import { axiosInstance } from "../../../config/interceptor";
import { SUBSCRIPTION_API } from "../../../utils/constants/apis.urls";

export const cancelSubscription = (userId: number) => {
    return axiosInstance.patch(`${SUBSCRIPTION_API.CANCEL_SUBSCRIPTION.replace(':user_id', userId.toString())}`);
};